import(/* webpackMode: "eager", webpackExports: ["div"] */ "/app/node_modules/motion/dist/es/motion/lib/react-client.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
